import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'

const CreateCustomerAttendModel = ({ modal, toggle, customerAttendListApi, isEdit, editData }) => {
    const { postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)

    const handleKeyPress = event => {
        const charCode = event.which || event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    };

    //  Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            failCount: isEdit ? editData?.FailCount : 0,
            successCount: isEdit ? editData?.SuccessCount : 0,
        },
        validationSchema: Yup.object({
            failCount: Yup.string().required("The fail count is required"),
            successCount: Yup.string().required("The suuccess count is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {
                isEdit
                    ? putApi("CustomerAttend/update", {
                        id: editData.Id,
                        failCount: parseInt(values.failCount),
                        successCount: parseInt(values.successCount),
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully updated", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setformSumitLoading(false)
                            toggle()
                            if (customerAttendListApi != '') {
                                customerAttendListApi()
                            }
                            validation.handleReset()
                        }
                    })
                    : postApi("CustomerAttend/create", {
                        failCount: parseInt(values.failCount),
                        successCount: parseInt(values.successCount),
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (customerAttendListApi != '') {
                                customerAttendListApi()
                            }
                            validation.handleReset()
                        }
                    })
            }
        },
    })


    // cancle handler
    const handleCancle = () => {
        toggle()
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="small"
            style={{ width: !isMobile ? "350px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Customer" : "Create Customer"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Fail Count
                                </Label>
                                <Input
                                    name="failCount"
                                    placeholder="0"
                                    type="text"
                                    maxLength="10"
                                    className="form-control-sm"
                                    onKeyPress={handleKeyPress}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.failCount || ""}
                                    invalid={
                                        validation.touched.failCount && validation.errors.failCount
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.failCount && validation.errors.failCount ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.failCount}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>
                        <Row>
                            <FormGroup className="mb-2">
                                <Label htmlFor="validationCustom03" className="required">
                                    Success Count
                                </Label>
                                <Input
                                    name="successCount"
                                    placeholder="0"
                                    type="text"
                                    maxLength="10"
                                    className="form-control-sm"
                                    onKeyPress={handleKeyPress}
                                    onChange={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.successCount || ""}
                                    invalid={
                                        validation.touched.successCount && validation.errors.successCount
                                            ? true
                                            : false
                                    }
                                />
                                {validation.touched.successCount && validation.errors.successCount ? (
                                    <FormFeedback type="invalid">
                                        {validation.errors.successCount}
                                    </FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Row>
                        <div className="text-end">
                            {isEdit ? (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={handleCancle}
                                >
                                    Cancle
                                </Button>
                            ) : (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    type="reset"
                                >
                                    Reset
                                </Button>
                            )}
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    color="secondary"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    user="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateCustomerAttendModel